import { CategoryId } from "@/services/collection/categories";
import type { Ref } from "vue";
import { readonly } from "vue";

const acceptedMimeTypes = "image/gif, image/jpeg, image/png, image/webp";

export function useAiImages(categoryId: Ref<CategoryId | undefined>) {
  const MaxImageCountPerCategory = new Map<CategoryId, number>([
    [CategoryId.SportsCards, 2],
    [CategoryId.Pokemon, 1],
  ]);

  const maxImagesCount = computed(() => {
    if (categoryId.value === undefined) {
      return 0;
    } else {
      const max = MaxImageCountPerCategory.get(categoryId.value);
      if (max === undefined) {
        throw new Error("Unspecified max image count for category: " + categoryId.value);
      } else {
        return max;
      }
    }
  });

  return {
    maxImagesCount: readonly(maxImagesCount),
    acceptedMimeTypes,
  };
}
